import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { FaUndo } from 'react-icons/fa';
import momentPropTypes from 'react-moment-proptypes';
import UserSearch from '@/shared/components/input/UserSearch';
import RelationSearch from '@/shared/components/input/RelationSearch';
import PeriodButtonGroup, {
  getPeriodDateFromUntil,
  pastToNowPeriods,
} from '@/shared/components/PeriodButtonGroup';
import { CanRead } from '@/shared/components/security';
import DelayedDateRangePicker from '@/shared/components/input/DelayedDateRangePicker';
import intlShape from '@/shared/utils/intlShape';
import EnumMultiSelect from '../../shared/components/input/multiselect/EnumMultiSelect';
import AuthService from '../../shared/services/AuthService';
import messages from './jobMessages';

export const defaultFilters = {
  userId: null,
  dateFrom: null,
  dateUntil: null,
  period: null,
  jobType: [],

  jobStatus: [],
  entryStatus: [],
  relationId: null,
  relationName: null,
};

class JobOverviewFilters extends Component {
  static propTypes = {
    onFilterChange: PropTypes.func.isRequired,
    filters: PropTypes.shape({
      userId: PropTypes.string,
      period: PropTypes.string,
      dateFrom: momentPropTypes.momentObj,
      dateUntil: momentPropTypes.momentObj,
      relationId: PropTypes.string,
      jobType: PropTypes.arrayOf(PropTypes.number),
      jobStatus: PropTypes.arrayOf(PropTypes.number),
      entryStatus: PropTypes.arrayOf(PropTypes.number),
    }),
    onResetFilters: PropTypes.func.isRequired,
    hasColumnFilters: PropTypes.bool,
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    filters: defaultFilters,
    hasColumnFilters: false,
  };

  filterChanged = filter => {
    const { filters, onFilterChange } = this.props;
    const newFilters = { ...filters, ...filter };

    if (JSON.stringify(filters) !== JSON.stringify(newFilters)) onFilterChange(newFilters);
  };
  userChanged = item => {
    this.filterChanged({
      userId: (item && item.id) || null,
    });
  };
  dateChanged = (dateFrom, dateUntil) => {
    this.filterChanged({ dateFrom, dateUntil, period: null });
  };
  relationChanged = item => {
    if (!item || !item.key) {
      this.filterChanged({ relationId: null, relationName: null });
    } else {
      this.filterChanged({
        relationId: item.key,
        relationName: item.label,
      });
    }
  };
  setPeriod = period => {
    this.filterChanged(getPeriodDateFromUntil(period));
  };

  componentDidMount() {
    const { filters } = this.props;

    if (filters && filters.period) {
      this.setPeriod(filters.period);
    }

    this.defaultFiltersWithUser = {
      ...defaultFilters,
      userId: AuthService.isSupport() ? null : AuthService.getUserId(),
    };
  }

  componentDidUpdate(prevProps) {
    const { filters } = this.props;
    const { filters: oldFilters = {} } = prevProps;
    if (filters.period !== oldFilters.period) {
      this.setPeriod(filters.period);
    }
  }

  resetFilters = () => {
    this.filterChanged(this.defaultFiltersWithUser);
  };

  render() {
    const { filters, intl, onResetFilters, hasColumnFilters } = this.props;
    let initRelation = null;
    if (filters.relationId && filters.relationName) {
      initRelation = {
        key: filters.relationId,
        label: filters.relationName,
      };
    }

    const hasFilters =
      hasColumnFilters || JSON.stringify(filters) !== JSON.stringify(this.defaultFiltersWithUser);
    return (
      <div className="container-fluid margin20B">
        <div className="row">
          <div className="col-lg-3 col-md-6">
            <div className="form-group">
              <DelayedDateRangePicker
                startDate={filters.dateFrom}
                endDate={filters.dateUntil}
                onDatesChange={({ startDate, endDate }) => this.dateChanged(startDate, endDate)}
                block
              />
            </div>
          </div>
          <div className="col-lg-12">
            <div className="form-group">
              <PeriodButtonGroup
                dateFrom={filters.dateFrom}
                dateUntil={filters.dateUntil}
                period={filters.period}
                visiblePeriods={pastToNowPeriods}
                onChange={this.filterChanged}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <CanRead on="Settings">
            <div className="col-lg-3 col-md-6">
              <div className="form-group">
                <UserSearch
                  onChange={this.userChanged}
                  value={filters.userId}
                  placeholder={intl.formatMessage(messages.CreatedBy)}
                />
              </div>
            </div>
          </CanRead>
          <div className="col-lg-3 col-md-6">
            <div className="form-group">
              <EnumMultiSelect
                type="JobType"
                selection={filters.jobType}
                orderByLabel
                onChange={value => this.filterChanged({ jobType: value })}
                placeholder={intl.formatMessage(messages.JobType)}
              />
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="form-group">
              <EnumMultiSelect
                type="JobStatus"
                selection={filters.entryStatus}
                orderByLabel
                onChange={value => this.filterChanged({ entryStatus: value })}
                placeholder={intl.formatMessage(messages.JobEntryStatus)}
              />
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="form-group">
              <RelationSearch onChange={this.relationChanged} initialSelectedItem={initRelation} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-2 col-md-4">
            {hasFilters && (
              <button
                type="button"
                className="btn btn-default btn-reset"
                onClick={() => onResetFilters()}
              >
                <FaUndo className="react-icon" />
                &nbsp;
                <FormattedMessage {...messages.ResetFilters} />
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(JobOverviewFilters);
